// removed by extract-text-webpack-plugin
module.exports = {"carouselOrders":"qempo_CarouselProducts_carouselOrders-3jH_5Ro","seeMore":"qempo_CarouselProducts_seeMore-3hoUR0U","button":"qempo_CarouselProducts_button-eMwMGO7"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/CarouselProducts/CarouselProducts.scss
// module id = 1975
// module chunks = 0